import { Outlet } from "react-router-dom";

export default function Issue() {
  return <Outlet />;
}
